import { IStoreItem } from "./interfaces";

type TType = "click" | "hover";
export type TStoreEventHoverType = "enter" | "leave" | "move";
export type TStoreEventClickCallback = () => void;
export type TStoreEventHoverCallback = (type: TStoreEventHoverType) => void;

interface IItem {
	click?: TStoreEventClickCallback;
	hover?: TStoreEventHoverCallback;
}

const mapping: Map<IStoreItem["id"], IItem> = new Map();

function createItemFromId(id: IStoreItem["id"]) {
	mapping.set(id, {
		click: null,
		hover: null,
	});
}

export function addClickEventToStoreItem(id: IStoreItem["id"], cb: TStoreEventClickCallback) {
	if (!mapping.has(id)) {
		createItemFromId(id);
	}

	mapping.get(id).click = cb;
}

export function addHoverEventToStoreItem(id: IStoreItem["id"], cb: TStoreEventHoverCallback) {
	if (!mapping.has(id)) {
		createItemFromId(id);
	}

	mapping.get(id).hover = cb;
}

export function removeAllEventsFromStoreItem(id: IStoreItem["id"]) {
	if (mapping.has(id)) {
		mapping.delete(id);
	}
}

export function removeEventFromStoreItem(id: IStoreItem["id"], type: TType) {
	if (mapping.has(id)) {
		switch (type) {
			case "click":
				mapping.get(id).click = null;
				break;

			case "hover":
				mapping.get(id).hover = null;
				break;

			default:
		}
	}
}

export function callClickEvent(id: IStoreItem["id"]) {
	if (mapping.has(id)) {
		const data = mapping.get(id);

		//console.log("callClickEvent", id, data);

		data.click && data.click();
	}
}

export function callHoverEvent(id: IStoreItem["id"], type: TStoreEventHoverType) {
	if (mapping.has(id)) {
		const data = mapping.get(id);

		data.hover && data.hover(type);
	}
}
